import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { QUOTE_SERVICE } from "../../shared/url.consts";
import { AppInsightsErrorType } from "../../shared/insights/app-insights.consts";
import { sendAppInsightsServerError } from "../../shared/insights/app-insights.utils";
import { DirectIncome } from "../../types/direct-incomes";

export const getDirectIncomes = async () => {
  return axios.get<DirectIncome[]>(
    `${QUOTE_SERVICE}/common-values/direct-incomes`
  );
};

export const getCategorisedDirectIncomes = async () => {
  return axios.get<DirectIncome[]>(
    `${QUOTE_SERVICE}/common-values/direct-incomes/categorised`
  );
};

export const getDirectIncomesResponse = async () => {
  try {
    const response = await getDirectIncomes();
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Unexpected response received: ${response.status}`);
    }
  } catch (err) {
    sendAppInsightsServerError(
      `error getting direct incomes: ${err}`,
      AppInsightsErrorType.GET_DIRECT_INCOMES
    );
    throw err;
  }
};

export const getCategorisedDirectIncomesResponse = async () => {
  try {
    const response = await getCategorisedDirectIncomes();
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Unexpected response received: ${response.status}`);
    }
  } catch (err) {
    sendAppInsightsServerError(
      `error getting categorised direct incomes: ${err}`,
      AppInsightsErrorType.GET_CATEGORISED_DIRECT_INCOMES
    );
    throw err;
  }
};

export const fetchGetDirectIncomes = createAsyncThunk(
  "direct-incomes/get",
  getDirectIncomesResponse
);

export const fetchGetCategorisedDirectIncomes = createAsyncThunk(
  "direct-incomes/get-categorised",
  getCategorisedDirectIncomesResponse
);
